import React from "react";
import { Box, Typography, Button } from "@mui/material";

// Replace with actual background image path when available
import bgBlock from "../assets/tamales-salinas/bg.jpg";

const StoreCard = ({ store }) => {
  return (
    <Box
      onClick={() => {
        window.location.href = "https://pide.mennu.mx/salinasjuarez";
      }}
      sx={{
        width: "100%",
        minHeight: 180, // Increased to fit the button
        py: 2,
        backgroundImage: `url(${bgBlock})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "12px",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
        },
      }}
    >
      {/* Semi-transparent blue overlay if needed (the image might already have it) */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(185, 28, 28, 0.65)", // Darker red overlay
          zIndex: 1,
        }}
      />
      
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          textAlign: "center",
          px: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100%", // Take up full height of card
          justifyContent: "space-between", // Spread items, pushing button to bottom
          py: 1, // Slight padding to not hit the edges
          width: "100%", // Ensures it fills the container
        }}
      >
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <Typography
            variant="subtitle2"
            sx={{
              color: "white",
              fontWeight: "bold",
              mb: 0.5,
              textShadow: "1px 1px 3px rgba(0,0,0,0.8)", // Stronger text shadow
              fontSize: "0.95rem"
            }}
          >
            {store.municipality}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: "white",
              fontWeight: 800,
              lineHeight: 1.1,
              mb: store.hasAutoTamal ? 1 : 2, // More margin if there's no autotamal text below it
              textShadow: "1px 1px 4px rgba(0,0,0,0.9)", // Stronger text shadow
              fontSize: "1.3rem"
            }}
          >
            {store.name}
          </Typography>
          {store.hasAutoTamal && (
            <Box 
              sx={{ 
                backgroundColor: "rgba(0, 0, 0, 0.45)", // Semi-transparent dark background
                padding: "4px 8px", 
                borderRadius: "6px",
                display: "inline-block", // So it only takes up as much width as the text
                mb: 1.5,
                alignSelf: "center" // Center it horizontally since parent is flex-col
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  color: "#ffcccc", // Pure white for better contrast
                  display: "block",
                  fontSize: "0.75rem", // Slightly larger
                  fontWeight: 600, // Make it slightly bolder
                  lineHeight: 1.3,
                }}
              >
                ¡Cuenta con Autotamal!
              </Typography>
            </Box>
          )}
        </Box>
        
        <Button
          variant="contained"
          size="medium" // Made larger
          sx={{
            backgroundColor: "#ffffff", // White background
            color: "#dc2626", // Red text
            fontWeight: "bold",
            borderRadius: "24px", // Increased radius slightly to match size
            px: 4, // More horizontal padding
            py: 0.75, // More vertical padding
            fontSize: "1rem", // Larger text
            textTransform: "none",
            boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
            "&:hover": {
              backgroundColor: "#f3f4f6", // Very light gray on hover
            },
            mt: "auto", // Ensure the button stays pinned to the bottom
            mb: 0.5
          }}
          onClick={(e) => {
            e.stopPropagation(); // Prevent double triggering with the card's onClick
            window.location.href = "https://pide.mennu.mx/salinasjuarez";
          }}
        >
          Pide aquí
        </Button>
      </Box>
    </Box>
  );
};

export default StoreCard;
